<template>
  <div class="position-relative flex-center p-3 mb-7 no-overflow shadow-type-3">
    <div class="position-absolute w-75 h-25 top-0 left-0 right-0 m-auto bg-light-light-5 z-plus-1" />
    <div class="position-absolute h-75 w-25 top-0 bottom-0 right-0 m-auto bg-light-light-5 z-plus-1" />
    <div class="position-absolute w-75 h-25 bottom-0 left-0 right-0 m-auto bg-light-light-5 z-plus-1" />
    <div class="position-absolute h-75 w-25 top-0 left-0 bottom-0 m-auto bg-light-light-5 z-plus-1" />
    <video
      id="demoVideo"
      class="video z-plus-2"
      autoplay
      playsinline
      loop
      muted
      type="video/mp4"
      :src="require('@/assets/video/scan-preview.mp4')"
      :poster="require('@/assets/images/scan-preview.png')">
    </video>
  </div>
</template>

<script>
import enableInlineVideo from 'iphone-inline-video'

export default {
  name: 'ScanDemo',
  mounted() {
    var video = document.querySelector('#demoVideo')
    enableInlineVideo(video)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/@core/globals';

.video {
  width: 140px;
  height: 140px;

  @media #{$sm-up} {
    width: 180px;
    height: 180px;
  }
}
</style>

<style>
.IIV::-webkit-media-controls-play-button,
.IIV::-webkit-media-controls-start-playback-button {
  opacity: 0;
  pointer-events: none;
  width: 5px;
}
</style>
